import Vue from 'vue';
import store from '../../store';

// When the request succeeds
const success = (response, context) => {
    if (response.status === 'success') {
      context.closeModal('#get-properties-modal');
      $('.sync-in-process-modal').addClass('show');
      $('body').addClass('modal-open');
      $('body').append('<div class="modal-backdrop fade show"></div>');
      $(".modal-content").css({"display": "block"});
      $(".navbar").css({"z-index": "0"});
      store.dispatch('updateIsSyncProgress', true);
    }
};

// When the request fails
const failed = (error, context) => {

};

export default (context, data) => {
    return Vue.$http.post('/rentals/sync-data', data)
        .then((response) => {
            if (response && response.status === 200) {
                success(response.data, context);
            } else {
              failed(response, context);
            }
    }).catch((error) => {
        failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/syncData.js